import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.div`
  width: 45%;
  border-radius: 20px;
  margin-top: 5px;
  
  @media (max-width: ${defaultBreakpoints.medium}) {
    width: 100%;
    margin-top: 0;
  }
`;

export const StyledLabel = styled.p`
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; 

`;